/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
export type EntityScanInputKind =
  (typeof EntityScanInputKind)[keyof typeof EntityScanInputKind];

export const EntityScanInputKind = {
  author_scan: "author_scan",
  quote_scan: "quote_scan",
} as const;

export interface EntityScanInput {
  kind: EntityScanInputKind;
  /**
   * @maxLength 160
   * @nullable
   */
  author?: string | null;
  /**
   * @minimum 0
   * @maximum 2
   */
  threshold: number;
}

export interface AuthorPairInput {
  /**
   * @minLength 1
   * @maxLength 160
   */
  source: string;
  /**
   * @minLength 1
   * @maxLength 160
   */
  target: string;
}

export type AuthorMergeInputMetadataResolution =
  (typeof AuthorMergeInputMetadataResolution)[keyof typeof AuthorMergeInputMetadataResolution];

export const AuthorMergeInputMetadataResolution = {
  preserve_survivor: "preserve_survivor",
} as const;

export interface AuthorMergeInput {
  /**
   * @minLength 1
   * @maxLength 160
   */
  source: string;
  /**
   * @minLength 1
   * @maxLength 160
   */
  target: string;
  token: string;
  /**
   * @minLength 3
   * @maxLength 1000
   */
  reason: string;
  /**
   * @minimum 0
   * @maximum 2
   */
  quoteThreshold: number;
  metadataResolution?: AuthorMergeInputMetadataResolution;
}

export type EntityCandidateDecisionDecision =
  (typeof EntityCandidateDecisionDecision)[keyof typeof EntityCandidateDecisionDecision];

export const EntityCandidateDecisionDecision = {
  reject: "reject",
  merge: "merge",
} as const;

export interface EntityCandidateDecision {
  decision: EntityCandidateDecisionDecision;
  /**
   * @minLength 3
   * @maxLength 1000
   */
  reason: string;
  survivor?: string;
}

export type EntityJobControlAction =
  (typeof EntityJobControlAction)[keyof typeof EntityJobControlAction];

export const EntityJobControlAction = {
  retry: "retry",
  cancel: "cancel",
} as const;

export interface EntityJobControl {
  action: EntityJobControlAction;
}

export type EntityResolutionJobConfig = { [key: string]: unknown };

export type EntityResolutionJobProgress = { [key: string]: unknown };

export interface EntityResolutionJob {
  id: number;
  kind: string;
  state: string;
  config: EntityResolutionJobConfig;
  progress: EntityResolutionJobProgress;
  cursor: string;
  /** @nullable */
  error: string | null;
}

export type EntityResolutionCandidateEvidence = { [key: string]: unknown };

export interface EntityResolutionCandidate {
  id: number;
  kind: string;
  source: string;
  target: string;
  sourceRevision: string;
  targetRevision: string;
  state: string;
  /** @nullable */
  distance: number | null;
  evidence: EntityResolutionCandidateEvidence;
}

export type EntityResolutionWorkspaceCounts = {
  pending: number;
  rejected: number;
  merged: number;
};

export type EntityResolutionWorkspaceCalibration = { [key: string]: unknown };

export interface EntityResolutionWorkspace {
  counts: EntityResolutionWorkspaceCounts;
  totalCandidates: number;
  candidates: EntityResolutionCandidate[];
  jobs: EntityResolutionJob[];
  calibration: EntityResolutionWorkspaceCalibration;
}

export type AuthorMergePreviewSource = { [key: string]: unknown };

export type AuthorMergePreviewTarget = { [key: string]: unknown };

export type AuthorMergePreviewCollisionsItem = { [key: string]: unknown };

export interface AuthorMergePreview {
  source: AuthorMergePreviewSource;
  target: AuthorMergePreviewTarget;
  token: string;
  sourceRevision: string;
  targetRevision: string;
  conflicts: string[];
  collisions: AuthorMergePreviewCollisionsItem[];
}

export type QuoteCorrectionPatchEra =
  (typeof QuoteCorrectionPatchEra)[keyof typeof QuoteCorrectionPatchEra];

export const QuoteCorrectionPatchEra = {
  ancient: "ancient",
  medieval: "medieval",
  enlightenment: "enlightenment",
  romantic: "romantic",
  modern: "modern",
  contemporary: "contemporary",
} as const;

export type QuoteCorrectionPatchSourceType =
  (typeof QuoteCorrectionPatchSourceType)[keyof typeof QuoteCorrectionPatchSourceType];

export const QuoteCorrectionPatchSourceType = {
  author: "author",
  film: "film",
  tv: "tv",
  speech: "speech",
  athlete: "athlete",
  scientist: "scientist",
  musician: "musician",
  comedian: "comedian",
  business: "business",
  historical: "historical",
  unknown: "unknown",
  kaggle: "kaggle",
  user_submitted: "user_submitted",
  user_authored: "user_authored",
} as const;

/**
 * @nullable
 */
export type QuoteCorrectionPatchQuoteForm =
  | (typeof QuoteCorrectionPatchQuoteForm)[keyof typeof QuoteCorrectionPatchQuoteForm]
  | null;

export const QuoteCorrectionPatchQuoteForm = {
  standalone: "standalone",
  excerpt: "excerpt",
  verse: "verse",
  dialogue: "dialogue",
  lyric: "lyric",
  unknown: "unknown",
} as const;

/**
 * @nullable
 */
export type QuoteCorrectionPatchWorkType =
  | (typeof QuoteCorrectionPatchWorkType)[keyof typeof QuoteCorrectionPatchWorkType]
  | null;

export const QuoteCorrectionPatchWorkType = {
  book: "book",
  poem: "poem",
  play: "play",
  film: "film",
  tv: "tv",
  speech: "speech",
  song: "song",
  interview: "interview",
  none: "none",
  unknown: "unknown",
} as const;

export type QuoteCorrectionPatchStatus =
  (typeof QuoteCorrectionPatchStatus)[keyof typeof QuoteCorrectionPatchStatus];

export const QuoteCorrectionPatchStatus = {
  candidate: "candidate",
  approved: "approved",
  rejected: "rejected",
} as const;

export type QuoteCorrectionPatchVisibility =
  (typeof QuoteCorrectionPatchVisibility)[keyof typeof QuoteCorrectionPatchVisibility];

export const QuoteCorrectionPatchVisibility = {
  private: "private",
  library: "library",
  community: "community",
} as const;

export interface QuoteCorrectionPatch {
  /** @minLength 1 */
  text?: string;
  /** @minLength 1 */
  author?: string;
  era?: QuoteCorrectionPatchEra;
  /** @nullable */
  year?: number | null;
  work?: string;
  sourceType?: QuoteCorrectionPatchSourceType;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  quoteForm?: QuoteCorrectionPatchQuoteForm;
  /** @nullable */
  workType?: QuoteCorrectionPatchWorkType;
  containsProfanity?: boolean;
  containsSexualContext?: boolean;
  status?: QuoteCorrectionPatchStatus;
  visibility?: QuoteCorrectionPatchVisibility;
  /** @maxItems 3 */
  tagIds?: number[];
}

export type QuoteCurationInputAction =
  (typeof QuoteCurationInputAction)[keyof typeof QuoteCurationInputAction];

export const QuoteCurationInputAction = {
  edit: "edit",
  remove: "remove",
  merge: "merge",
} as const;

export interface QuoteCurationInput {
  /** @minimum 0 */
  revision: number;
  /**
   * @minLength 3
   * @maxLength 1000
   */
  reason: string;
  action: QuoteCurationInputAction;
  patch?: QuoteCorrectionPatch;
  /** @minimum 1 */
  survivorId?: number;
  /** @minimum 0 */
  survivorRevision?: number;
}

export interface QuoteCurationRetryInput {
  /** @minimum 0 */
  revision: number;
}

export type QuoteStatus = (typeof QuoteStatus)[keyof typeof QuoteStatus];

export const QuoteStatus = {
  candidate: "candidate",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface Quote {
  /** @nullable */
  sourceType?: string | null;
  /** @nullable */
  visibility?: string | null;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  quoteForm?: string | null;
  /** @nullable */
  workType?: string | null;
  /** @nullable */
  containsProfanity?: boolean | null;
  /** @nullable */
  containsSexualContext?: boolean | null;
  /** @nullable */
  ownerUsername?: string | null;
  id: number;
  text: string;
  author: string;
  era: string;
  /** @nullable */
  year?: number | null;
  work: string;
  status: QuoteStatus;
  createdAt: string;
  updatedAt: string;
}

export type TagCategory = (typeof TagCategory)[keyof typeof TagCategory];

export const TagCategory = {
  theme: "theme",
  emotion: "emotion",
  time_period: "time_period",
  author_style: "author_style",
  medium: "medium",
} as const;

export interface Tag {
  id: number;
  name: string;
  /** Number of accessible quotes, when returned by the tag list endpoint. */
  count?: number;
  category: TagCategory;
}

export type QuoteWithTags = Quote & {
  tags: Tag[];
};

export interface QuoteResolutionCandidate {
  quote: QuoteWithTags;
  revision: number;
}

/**
 * @nullable
 */
export type QuoteCurationWorkspaceWork = { [key: string]: unknown } | null;

export type QuoteCurationWorkspaceHistoryItem = { [key: string]: unknown };

export type QuoteCurationWorkspaceFactsItem = { [key: string]: unknown };

export type QuoteCurationWorkspaceCounts = { [key: string]: number };

export interface QuoteCurationWorkspace {
  archived?: boolean;
  quote: QuoteWithTags;
  revision: number;
  overrides: string[];
  /** @nullable */
  work?: QuoteCurationWorkspaceWork;
  history: QuoteCurationWorkspaceHistoryItem[];
  facts: QuoteCurationWorkspaceFactsItem[];
  counts: QuoteCurationWorkspaceCounts;
}

export type QuoteCurationPreviewCounts = { [key: string]: number };

export interface QuoteCurationPreview {
  changedFields: string[];
  stages: string[];
  counts: QuoteCurationPreviewCounts;
  warnings: string[];
}

export interface QuoteCurationResult {
  action: string;
  /** @nullable */
  quoteId: number | null;
  revision: number;
  message: string;
}

export interface HealthStatus {
  status: string;
}

export interface PaginatedQuotes {
  data: QuoteWithTags[];
  total: number;
  page: number;
  pageSize: number;
}

export interface CreateQuoteBody {
  text: string;
  author: string;
  era: string;
  /** @nullable */
  year?: number | null;
  work: string;
  tags?: string[];
}

export type UpdateQuoteStatusBodyStatus =
  (typeof UpdateQuoteStatusBodyStatus)[keyof typeof UpdateQuoteStatusBodyStatus];

export const UpdateQuoteStatusBodyStatus = {
  approved: "approved",
  rejected: "rejected",
} as const;

export interface UpdateQuoteStatusBody {
  status: UpdateQuoteStatusBodyStatus;
}

export interface FavoriteToggleResponse {
  favorited: boolean;
  quoteId: number;
}

export interface QuoteCluster {
  label: string;
  percentage: number;
}

export type RecommendedQuote = QuoteWithTags & {
  /** @nullable */
  reasonSnippet: string | null;
  /** @nullable */
  score: number | null;
};

export type UserProfileNotifyFrequency =
  (typeof UserProfileNotifyFrequency)[keyof typeof UserProfileNotifyFrequency];

export const UserProfileNotifyFrequency = {
  daily: "daily",
  weekly: "weekly",
} as const;

export interface UserProfile {
  /** @nullable */
  username: string | null;
  /** @nullable */
  avatarUrl: string | null;
  currentStreak: number;
  longestStreak: number;
  /** @nullable */
  lastSavedAt: string | null;
  notifyEnabled: boolean;
  notifyFrequency: UserProfileNotifyFrequency;
  /**
   * @minimum 0
   * @maximum 23
   */
  notifyHour: number;
  /** @nullable */
  notifyEmail: string | null;
  allowProfaneQuotes: boolean;
  allowSexualQuotes: boolean;
}

export type UpdateNotificationSettingsBodyNotifyFrequency =
  (typeof UpdateNotificationSettingsBodyNotifyFrequency)[keyof typeof UpdateNotificationSettingsBodyNotifyFrequency];

export const UpdateNotificationSettingsBodyNotifyFrequency = {
  daily: "daily",
  weekly: "weekly",
} as const;

export interface UpdateNotificationSettingsBody {
  notifyEnabled?: boolean;
  notifyFrequency?: UpdateNotificationSettingsBodyNotifyFrequency;
  /**
   * @minimum 0
   * @maximum 23
   */
  notifyHour?: number;
  /** @nullable */
  notifyEmail?: string | null;
}

export interface UpdateContentPreferencesBody {
  allowProfaneQuotes?: boolean;
  allowSexualQuotes?: boolean;
}

export interface UpdateProfileBody {
  /**
   * @minLength 3
   * @maxLength 30
   */
  username?: string;
  avatarUrl?: string;
}

export interface RequestUploadUrlBody {
  name: string;
  size: number;
  contentType: string;
}

export type RequestUploadUrlResponseMetadata = {
  name: string;
  size: number;
  contentType: string;
};

export interface RequestUploadUrlResponse {
  uploadURL: string;
  objectPath: string;
  metadata: RequestUploadUrlResponseMetadata;
}

export interface AuthorBioResponse {
  /** @nullable */
  bio: string | null;
  otherQuotes: QuoteWithTags[];
}

export interface SimilarAuthor {
  name: string;
  quoteCount: number;
  similarityScore: number;
}

export interface AuthorProfileResponse {
  themeClusters: QuoteCluster[];
  similarAuthors: SimilarAuthor[];
  /** True when the author has enough embeddings for a profile but the centroid job hasn't run yet. Use to show a "computing" placeholder instead of hiding the section entirely.
   */
  isPending?: boolean;
}

export interface PinnedQuote {
  /**
   * @minimum 1
   * @maximum 3
   */
  position: number;
  quote: QuoteWithTags;
}

export interface PinQuoteBody {
  /**
   * @minimum 1
   * @maximum 3
   */
  position: number;
  quoteId: number;
}

export interface UpdatePinnedQuotesResponse {
  success: boolean;
  count: number;
}

export interface EnrichmentPipelineStatus {
  /** Whether the checkpoint file was found and readable */
  found: boolean;
  /** Total number of chunks tracked in the checkpoint */
  total: number;
  /** Chunks whose results have been written back to the database */
  applied: number;
  /** Chunks with a batchId that are still being processed by OpenAI */
  inFlight: number;
  /** Chunks that ended in a terminal failure (failed, expired, or cancelled) */
  failed: number;
  /** Chunks not yet submitted to OpenAI */
  pending: number;
  /**
   * ISO timestamp of the most recently submitted chunk
   * @nullable
   */
  lastRunAt: string | null;
}

export interface HarvestStats {
  /** Total quotes in the corpus */
  total: number;
  /** Quotes with status approved */
  approved: number;
  /** Quotes with status candidate */
  candidate: number;
  /** Quotes with status rejected */
  rejected: number;
  /** Quotes where ai_verified is true */
  aiVerified: number;
  /** Quotes where ai_verified is false (explicitly failed verification) */
  aiUnverified: number;
  /** Quotes where ai_verified is null (not yet processed) */
  aiPending: number;
  /** Quotes with ai_confidence = high */
  confidenceHigh: number;
  /** Quotes with ai_confidence = medium */
  confidenceMedium: number;
  /** Quotes with ai_confidence = low */
  confidenceLow: number;
}

export interface PoorlyReceivedQuote {
  id: number;
  text: string;
  author: string;
  era: string;
  /** @nullable */
  year?: number | null;
  work: string;
  status: string;
  dismissalCount: number;
}

export interface ErrorResponse {
  error: string;
}

/**
 * @nullable
 */
export type QuoteSubmissionEra =
  | (typeof QuoteSubmissionEra)[keyof typeof QuoteSubmissionEra]
  | null;

export const QuoteSubmissionEra = {
  ancient: "ancient",
  medieval: "medieval",
  enlightenment: "enlightenment",
  romantic: "romantic",
  modern: "modern",
  contemporary: "contemporary",
} as const;

export type QuoteSubmissionStatus =
  (typeof QuoteSubmissionStatus)[keyof typeof QuoteSubmissionStatus];

export const QuoteSubmissionStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface QuoteSubmission {
  /** @nullable */
  quoteId?: number | null;
  /** @nullable */
  resolvedQuoteId?: number | null;
  /** @nullable */
  resolution?: string | null;
  /** @nullable */
  canonicalText?: string | null;
  /** @nullable */
  canonicalAuthor?: string | null;
  /** @nullable */
  canonicalWork?: string | null;
  id: number;
  userId: string;
  text: string;
  author: string;
  /** @nullable */
  source: string | null;
  /** @nullable */
  era: QuoteSubmissionEra;
  status: QuoteSubmissionStatus;
  isUserAuthor: boolean;
  /** @nullable */
  rejectionReason: string | null;
  /** @nullable */
  aiValidationStatus: string | null;
  submittedAt: string;
}

export type AdminSubmission = QuoteSubmission & {
  /** @nullable */
  submitterUsername: string | null;
};

/**
 * @nullable
 */
export type SubmitQuoteBodyEra =
  | (typeof SubmitQuoteBodyEra)[keyof typeof SubmitQuoteBodyEra]
  | null;

export const SubmitQuoteBodyEra = {
  ancient: "ancient",
  medieval: "medieval",
  enlightenment: "enlightenment",
  romantic: "romantic",
  modern: "modern",
  contemporary: "contemporary",
} as const;

export interface SubmitQuoteBody {
  /**
   * At most 600 Unicode code points after trimming; enforced by the server. The transport ceiling permits supplementary Unicode characters.
   * @minLength 5
   * @maxLength 1200
   */
  text: string;
  /**
   * @minLength 1
   * @maxLength 200
   */
  author?: string;
  /**
   * @maxLength 500
   * @nullable
   */
  source?: string | null;
  /** @nullable */
  era?: SubmitQuoteBodyEra;
  /** Set to true if the submitter is claiming authorship of this quote. OpenAI will still verify — if a known real-world author is found, they take precedence. */
  isUserAuthor?: boolean;
}

export interface SubmitQuoteResponse {
  submission: QuoteSubmission;
  /** @nullable */
  nextSubmitAt: string | null;
}

export interface SubmitRateLimitResponse {
  error: string;
  nextSubmitAt: string;
}

export type SubmissionWithVotes = QuoteSubmission & {
  /** Number of upvotes on the approved quote (0 if not yet approved) */
  upvotes: number;
  /** Number of downvotes on the approved quote (0 if not yet approved) */
  downvotes: number;
};

export interface MySubmissionsResponse {
  submissions: SubmissionWithVotes[];
  /** @nullable */
  nextSubmitAt: string | null;
}

export type UpdateSubmissionStatusBodyStatus =
  (typeof UpdateSubmissionStatusBodyStatus)[keyof typeof UpdateSubmissionStatusBodyStatus];

export const UpdateSubmissionStatusBodyStatus = {
  approved: "approved",
  rejected: "rejected",
} as const;

/**
 * @nullable
 */
export type UpdateSubmissionStatusBodyEra =
  | (typeof UpdateSubmissionStatusBodyEra)[keyof typeof UpdateSubmissionStatusBodyEra]
  | null;

export const UpdateSubmissionStatusBodyEra = {
  ancient: "ancient",
  medieval: "medieval",
  enlightenment: "enlightenment",
  romantic: "romantic",
  modern: "modern",
  contemporary: "contemporary",
} as const;

export interface UpdateSubmissionStatusBody {
  status: UpdateSubmissionStatusBodyStatus;
  /** @nullable */
  era?: UpdateSubmissionStatusBodyEra;
  /**
   * Optional reason shown to the submitter when their quote is rejected.
   * @nullable
   */
  rejectionReason?: string | null;
}

export type VoteQuoteBodyVote =
  (typeof VoteQuoteBodyVote)[keyof typeof VoteQuoteBodyVote];

export const VoteQuoteBodyVote = {
  up: "up",
  down: "down",
} as const;

export interface VoteQuoteBody {
  vote: VoteQuoteBodyVote;
}

export type VoteQuoteResponseUserVote =
  (typeof VoteQuoteResponseUserVote)[keyof typeof VoteQuoteResponseUserVote];

export const VoteQuoteResponseUserVote = {
  up: "up",
  down: "down",
} as const;

export interface VoteQuoteResponse {
  upvotes: number;
  downvotes: number;
  userVote: VoteQuoteResponseUserVote;
}

/**
 * @nullable
 */
export type CommunityQuoteUserVote =
  | (typeof CommunityQuoteUserVote)[keyof typeof CommunityQuoteUserVote]
  | null;

export const CommunityQuoteUserVote = {
  up: "up",
  down: "down",
} as const;

export type CommunityQuote = QuoteWithTags & {
  /** @nullable */
  submittedByUsername: string | null;
  upvotes: number;
  downvotes: number;
  /** @nullable */
  userVote: CommunityQuoteUserVote;
};

export interface PaginatedCommunityQuotes {
  data: CommunityQuote[];
  total: number;
  page: number;
  pageSize: number;
}

export type FeedbackItemCategory =
  (typeof FeedbackItemCategory)[keyof typeof FeedbackItemCategory];

export const FeedbackItemCategory = {
  bug: "bug",
  general: "general",
  feature: "feature",
} as const;

export type FeedbackItemStatus =
  (typeof FeedbackItemStatus)[keyof typeof FeedbackItemStatus];

export const FeedbackItemStatus = {
  new: "new",
  triaged: "triaged",
  closed: "closed",
} as const;

export interface FeedbackItem {
  id: number;
  /** @nullable */
  userId: string | null;
  category: FeedbackItemCategory;
  message: string;
  /** @nullable */
  contactEmail: string | null;
  /** @nullable */
  pageUrl: string | null;
  /** @nullable */
  userAgent: string | null;
  status: FeedbackItemStatus;
  /** @nullable */
  adminNotes: string | null;
  createdAt: string;
  updatedAt: string;
  /**
   * Joined from user_profiles when userId is set; null for anonymous submissions or when GET joins are not applied (e.g. on the POST response).
   * @nullable
   */
  submitterUsername?: string | null;
}

export type CreateFeedbackBodyCategory =
  (typeof CreateFeedbackBodyCategory)[keyof typeof CreateFeedbackBodyCategory];

export const CreateFeedbackBodyCategory = {
  bug: "bug",
  general: "general",
  feature: "feature",
} as const;

export interface CreateFeedbackBody {
  category: CreateFeedbackBodyCategory;
  /**
   * @minLength 10
   * @maxLength 2000
   */
  message: string;
  /**
   * @maxLength 320
   * @nullable
   */
  contactEmail?: string | null;
  /**
   * @maxLength 2000
   * @nullable
   */
  pageUrl?: string | null;
}

export type UpdateFeedbackBodyStatus =
  (typeof UpdateFeedbackBodyStatus)[keyof typeof UpdateFeedbackBodyStatus];

export const UpdateFeedbackBodyStatus = {
  new: "new",
  triaged: "triaged",
  closed: "closed",
} as const;

export interface UpdateFeedbackBody {
  status?: UpdateFeedbackBodyStatus;
  /**
   * @maxLength 4000
   * @nullable
   */
  adminNotes?: string | null;
}

export interface EnrichmentGovernanceSummary {
  policyVersion: string;
  shadowMode: boolean;
  activeAuthorOverrides: number;
  recordedAuthorDecisions: number;
  recordedClassifications: number;
  recordedProjections: number;
  queuedWorkItems: number;
  inFlightWorkItems: number;
  modelCompletedWorkItems: number;
  failedWorkItems: number;
  completedWorkItems: number;
}

export type AuthorNotabilityReviewTier =
  (typeof AuthorNotabilityReviewTier)[keyof typeof AuthorNotabilityReviewTier];

export const AuthorNotabilityReviewTier = {
  canonical: "canonical",
  notable: "notable",
  marginal: "marginal",
  unknown: "unknown",
} as const;

export interface AuthorNotabilityReview {
  authorName: string;
  tier: AuthorNotabilityReviewTier;
  /** @nullable */
  rationale: string | null;
  source: string;
  isOverride: boolean;
  quoteCount: number;
  createdAt: string;
}

export type AuthorNotabilityReviewList = AuthorNotabilityReview[];

export type AuthorNotabilityOverrideTier =
  (typeof AuthorNotabilityOverrideTier)[keyof typeof AuthorNotabilityOverrideTier];

export const AuthorNotabilityOverrideTier = {
  canonical: "canonical",
  notable: "notable",
  marginal: "marginal",
  unknown: "unknown",
} as const;

export interface AuthorNotabilityOverride {
  tier: AuthorNotabilityOverrideTier;
  /**
   * @minLength 4
   * @maxLength 4000
   */
  rationale: string;
}

export interface EnrichmentBlastRadiusSample {
  quoteId: number;
  author: string;
  currentStatus: string;
  currentVisibility: string;
  proposedStatus: string;
  proposedVisibility: string;
  reasonCode: string;
}

export interface EnrichmentBlastRadius {
  totalQuotes: number;
  totalEvaluated: number;
  unchanged: number;
  wouldApprove: number;
  wouldWithdrawPublic: number;
  needsFacts: number;
  samples: EnrichmentBlastRadiusSample[];
}

export interface EnrichmentWorkItemInput {
  /** @nullable */
  quoteId?: number | null;
  /**
   * @maxLength 512
   * @nullable
   */
  authorName?: string | null;
  /**
   * @minLength 3
   * @maxLength 128
   */
  reasonCode: string;
  /**
   * @minimum 0
   * @maximum 100
   */
  priority?: number;
}

export type EnrichmentWorkItemRequestTargetType =
  (typeof EnrichmentWorkItemRequestTargetType)[keyof typeof EnrichmentWorkItemRequestTargetType];

export const EnrichmentWorkItemRequestTargetType = {
  quote: "quote",
  author: "author",
} as const;

export interface EnrichmentWorkItemRequest {
  targetType: EnrichmentWorkItemRequestTargetType;
  /** @nullable */
  quoteId: number | null;
  /** @nullable */
  authorName: string | null;
  targetedQuotes: number;
  enqueuedQuotes: number;
  existingActiveQuotes: number;
  queuedWorkItems: number;
  inFlightWorkItems: number;
  failedWorkItems: number;
  completedWorkItems: number;
}

export type GetEntityResolutionParams = {
  kind?: GetEntityResolutionKind;
  state?: GetEntityResolutionState;
  /**
   * @minimum 0
   * @maximum 1000000
   */
  offset?: number;
  view?: GetEntityResolutionView;
};

export type GetEntityResolutionKind =
  (typeof GetEntityResolutionKind)[keyof typeof GetEntityResolutionKind];

export const GetEntityResolutionKind = {
  author: "author",
  quote: "quote",
} as const;

export type GetEntityResolutionState =
  (typeof GetEntityResolutionState)[keyof typeof GetEntityResolutionState];

export const GetEntityResolutionState = {
  pending: "pending",
  rejected: "rejected",
  merged: "merged",
} as const;

export type GetEntityResolutionView =
  (typeof GetEntityResolutionView)[keyof typeof GetEntityResolutionView];

export const GetEntityResolutionView = {
  identity: "identity",
  exploratory: "exploratory",
} as const;

export type GetPublicLibraryCount200 = {
  /** @minimum 0 */
  total: number;
};

export type GetQuotesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  pageSize?: number;
  tag?: string;
  status?: GetQuotesStatus;
  era?: string;
  /**
   * Free-text search across quote text and author
   */
  query?: string;
  /**
   * Filter by language bucket (english = English only, non-english = all other languages)
   */
  language?: GetQuotesLanguage;
  /**
   * Optional shuffle seed. When provided (and no author filter is set), quotes are returned in a deterministic pseudo-random order derived from this seed, so authors aren't clustered together while pagination stays consistent across pages.
   * @minimum 0
   */
  seed?: number;
};

export type GetQuotesStatus =
  (typeof GetQuotesStatus)[keyof typeof GetQuotesStatus];

export const GetQuotesStatus = {
  candidate: "candidate",
  approved: "approved",
  rejected: "rejected",
} as const;

export type GetQuotesLanguage =
  (typeof GetQuotesLanguage)[keyof typeof GetQuotesLanguage];

export const GetQuotesLanguage = {
  english: "english",
  "non-english": "non-english",
} as const;

export type GetQuotesRecommendationsParams = {
  /**
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
};

export type RecomputeCentroids202 = {
  message: string;
};

export type GetAuthorNotabilityReviewsParams = {
  /**
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type GetCommunityQuotesParams = {
  /**
   * @minimum 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 100
   */
  pageSize?: number;
  tag?: string;
  /**
   * Sort order for community quotes. "new" returns newest first; "top" sorts by net score (upvotes − downvotes) descending.
   */
  sort?: GetCommunityQuotesSort;
};

export type GetCommunityQuotesSort =
  (typeof GetCommunityQuotesSort)[keyof typeof GetCommunityQuotesSort];

export const GetCommunityQuotesSort = {
  new: "new",
  top: "top",
} as const;

export type GetPoorlyReceivedQuotesParams = {
  /**
   * @minimum 1
   */
  minDismissals?: number;
  /**
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
};

export type GetQuoteSimilarParams = {
  /**
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
};

export type GetAuthorBioParams = {
  /**
   * Quote ID to exclude from the "more from this author" list
   */
  exclude?: number;
};

export type GetFeedbackItemsParams = {
  status?: GetFeedbackItemsStatus;
};

export type GetFeedbackItemsStatus =
  (typeof GetFeedbackItemsStatus)[keyof typeof GetFeedbackItemsStatus];

export const GetFeedbackItemsStatus = {
  new: "new",
  triaged: "triaged",
  closed: "closed",
} as const;

export type SearchQuoteResolutionCandidatesParams = {
  query?: string;
  quoteId?: number;
};
